import { useState } from "react";
import { toast } from "sonner";
import { PenLine, Trash2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useFetch } from "../../lib/hooks";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Field } from "../common/Ui";

const API = process.env.REACT_APP_BACKEND_URL;

export function SignatureButton() {
  const [open, setOpen] = useState(false);
  const { data: sig, reload } = useFetch("/certificates/signature");
  const [f, setF] = useState(null);
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const cur = f || { name: sig?.name || "", title: sig?.title || "Kepala Sekolah" };
  const save = async (e) => {
    e.preventDefault();
    if (!cur.name.trim()) return toast.error("Nama penandatangan wajib diisi");
    const fd = new FormData();
    fd.append("name", cur.name); fd.append("title", cur.title);
    if (file) fd.append("file", file);
    setBusy(true);
    try { await api.post("/certificates/signature", fd); toast.success("Tanda tangan digital disimpan"); setFile(null); reload(); setOpen(false); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const clear = async () => { if (!window.confirm("Hapus tanda tangan digital? Sertifikat baru akan terbit tanpa tanda tangan.")) return; try { await api.delete("/certificates/signature"); toast.success("Tanda tangan dihapus"); setF(null); reload(); } catch (err) { toast.error(errMsg(err)); } };
  return <>
    <Button data-testid="signature-button" variant="outline" onClick={() => setOpen(true)}><PenLine className="h-4 w-4 mr-1" />Tanda Tangan{sig?.file_id && <span className="ml-1.5 h-2 w-2 rounded-full bg-emerald-500" />}</Button>
    <Dialog open={open} onOpenChange={setOpen}><DialogContent data-testid="signature-dialog"><DialogHeader><DialogTitle>Tanda Tangan Digital Kepala Sekolah</DialogTitle></DialogHeader>
      <p className="text-xs text-slate-500">Tanda tangan ini otomatis dicetak pada setiap sertifikat yang <b>diterbitkan</b>. Gunakan PNG latar transparan agar hasil terbaik.</p>
      <div className="rounded-md border bg-slate-50 p-3 flex items-center justify-center min-h-[96px]" data-testid="signature-preview">
        {file ? <img alt="preview" src={URL.createObjectURL(file)} className="max-h-24 object-contain" /> : sig?.url ? <img alt="tanda tangan" src={`${API}${sig.url}`} className="max-h-24 object-contain" /> : <span className="text-xs text-slate-400">Belum ada gambar tanda tangan</span>}
      </div>
      <form onSubmit={save} className="space-y-3">
        <Field label="Nama penandatangan"><Input data-testid="signature-name" value={cur.name} onChange={(e) => setF({ ...cur, name: e.target.value })} placeholder="Nama Kepala Sekolah" /></Field>
        <Field label="Jabatan"><Input data-testid="signature-title" value={cur.title} onChange={(e) => setF({ ...cur, title: e.target.value })} /></Field>
        <Field label="Gambar tanda tangan (PNG/JPG, maks 4 MB)"><Input data-testid="signature-file" type="file" accept="image/png,image/jpeg,image/webp" onChange={(e) => setFile(e.target.files?.[0] || null)} /></Field>
        {sig?.updated_at && <p className="text-[11px] text-slate-400">Terakhir diubah {sig.updated_at.slice(0, 10)} oleh {sig.updated_by}</p>}
        <div className="flex justify-between gap-2">
          {sig?.file_id ? <Button type="button" variant="ghost" className="text-red-600" data-testid="signature-clear" onClick={clear}><Trash2 className="h-4 w-4 mr-1" />Hapus</Button> : <span />}
          <Button type="submit" className="bg-[color:var(--brand-blue)] hover:bg-[color:var(--brand-blue-dark)]" data-testid="signature-save" disabled={busy}>{busy ? "Menyimpan..." : "Simpan"}</Button>
        </div>
      </form>
    </DialogContent></Dialog>
  </>;
}
